import { Component, inject, Input, LOCALE_ID, OnInit } from '@angular/core';
import { ProductComponent } from '../product/product.component';
import { NgFor, NgIf } from '@angular/common';
import { Product } from '../cart.model';
import { CartService } from '../cart.service';

import { TabViewModule } from 'primeng/tabview';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { DataViewModule } from 'primeng/dataview';
import { InsuranceDataviewComponent } from '../../insurance/insurance-dataview/insurance-dataview.component';
import { InsuranceService } from 'src/app/dashboard/insurance/insurance/insurance.service';
import { Section } from '@lemonsolutions/models';
import { APIService } from 'src/app/services/api.service';

@Component({
  selector: 'app-product-list',
  standalone: true,
  imports: [
    NgFor,
    NgIf,
    ProductComponent,
    TabViewModule,
    BadgeModule,
    AvatarModule,
    InsuranceDataviewComponent,
  ],
  templateUrl: './product-list.component.html',
  styleUrl: './product-list.component.scss',
})
export class ProductListComponent implements OnInit {
  apiService = inject(APIService);
  productType1: Product[] = [];
  productType2: Product[] = [];
  productType3: Product[] = [];
  productType4: Product[] = [];
  @Input() productType: number = 1;

  // cartService = inject(CartService);
  insuranceService = inject(InsuranceService);
  items!: Product[];
  // singleInsurances!: Product[];
  // doubleInsurances!: Product[];
  // tripleInsurances!: Product[];
  // quadraInsurances!: Product[];
  layout: 'list' | 'grid' = 'list';

  // combos: any;

  // products!: Product[];
  locale = inject(LOCALE_ID);

  constructor(public dv: DataViewModule) {
    // this.items = this.cartService.productList;
    // this.singleInsurances = this.cartService.productList.filter(
    //   element => element.productType == 1
    // );
    // this.doubleInsurances = this.cartService.productList.filter(
    //   element => element.productType == 2
    // );
    // this.tripleInsurances = this.cartService.productList.filter(
    //   element => element.productType == 3
    // );
    // this.quadraInsurances = this.cartService.productList.filter(
    //   element => element.productType == 4
    // );
    //   this.combos = this.cartService.comboList;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.insuranceService.getList(this.locale).subscribe((response: any[]) => {
      this.productType1 = response.filter(
        element => element.insurance_type_id == 1
      );

      this.productType2 = response.filter(
        element => element.insurance_type_id == 2
      );
      this.productType3 = response.filter(
        element => element.insurance_type_id == 6
      );
      this.productType4 = response.filter(
        element => element.insurance_type_id == 7
      );
      // this.singleInsurances = response.filter(element => element.insurance_type_id == 1);
      // this.doubleInsurances = response.filter(element => element.insurance_type_id == 2);
      // this.tripleInsurances = response.filter(element => element.insurance_type_id == 3);
      // this.quadraInsurances = response.filter(element => element.insurance_type_id == 4);
      // this._isLoading.set(false);
    });

    // this.apiService.getSections(9, 'es').subscribe(response => {
    //   this.sectionFAQElements = response?.data;
    // });
  }

  toggleLayout() {}
}
